var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNailAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 9.63665C7 6.60901 8.56609 3.80337 11.1256 2.24566C11.6638 1.91811 12.3362 1.91811 12.8744 2.24566C15.4339 3.80337 17 6.60901 17 9.63665V14.8997C17 15.4599 16.5523 15.9141 16 15.9141H8C7.44772 15.9141 7 15.4599 7 14.8997V9.63665Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 9.63668C18.5 9.46944 18.4959 9.30278 18.4879 9.13682C19.4393 10.4719 20 12.1122 20 13.8854V22H4V13.8854C4 12.1122 4.56072 10.4719 5.51211 9.13682C5.50406 9.30278 5.5 9.46944 5.5 9.63668V14.8998C5.5 16.3002 6.61929 17.4356 8 17.4356H16C17.3807 17.4356 18.5 16.3002 18.5 14.8998V9.63668ZM9.25 19.9714C9.25 20.3915 9.58579 20.7321 10 20.7321H14C14.4142 20.7321 14.75 20.3915 14.75 19.9714C14.75 19.5512 14.4142 19.2106 14 19.2106H10C9.58579 19.2106 9.25 19.5512 9.25 19.9714Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNailAlt);
export default __webpack_public_path__ + "static/media/nail-alt.7dd5f8ee1f082ae1cb61366d579b6073.svg";
export { ForwardRef as ReactComponent };